import type { CollectionCard } from "modules/collections/details/model/collection";

type CollectionCardTransitionKeyShape = Pick<
  CollectionCard,
  | "condition"
  | "dataId"
  | "finishes"
  | "language"
  | "purchasePrice"
  | "tradeItem"
>;

/**
 * Stable visual identity for one grouped Collection row.
 *
 * Concrete IDs remain the canonical mutation identity, but their set changes
 * whenever quantity changes. These fields mirror the backend browse grouping
 * so quantity updates retain the same visual row across optimistic and
 * authoritative results.
 */
export function collectionCardTransitionKey(
  card: CollectionCardTransitionKeyShape
): string {
  return JSON.stringify([
    card.dataId,
    card.finishes,
    card.language,
    card.condition,
    card.purchasePrice ?? null,
    Boolean(card.tradeItem),
  ]);
}
